import { Text } from '@change/ds-core-ui';
import { AddCardIcon } from '@change/ds-icons';

import { CheckBox } from '../../CheckBox';

type Props = {
	selected: boolean;
};

export const Header: React.FC<Props & React.RefAttributes<HTMLSpanElement>> = ({ selected, ref }) => {
	return (
		<div className="group flex flex-row justify-between" data-selected={selected}>
			<div className="flex flex-row gap-3">
				<AddCardIcon svgClassName="color-icon-weak" />
				<Text ref={ref} tabIndex={-1}>
					Add new card
				</Text>
			</div>
			<CheckBox />
		</div>
	);
};
